import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import styled from "styled-components";

import React from 'react';

function Recipe() {

    let params = useParams();
    const [details, setDetails] = useState({});
    const [activeTab, setActiveTab] = useState('instructions');

const fetchDetails = async () => {
    const data = await fetch(`https://api.spoonacular.com/recipes/${params.name}/information?apiKey=${process.env.REACT_APP_API_KEY}`);
    const detailData = await data.json();
setDetails(detailData);

}

useEffect(()=>{
    fetchDetails();
},[params.name]);



    return (
        <DetailWrapper>
          <div>
              <h2>{details.title}</h2>
              <img src={details.image} alt={details.title}/>
          </div>
                <Info>
                <Button className={activeTab === 'instructions' ? 'active' : '' } onClick = {()=>setActiveTab('instructions')}>Instructions</Button>
                <Button className={activeTab === 'ingredients' ? 'active' : '' } onClick = {()=>setActiveTab('ingredients')}>Ingredients</Button>
{activeTab === 'instructions' && (
    <div>
    <h3 dangerouslySetInnerHTML= {{__html: details.summary}}></h3>
    </div>
)}
{activeTab === 'ingredients' && (
    <div>
    <h3 dangerouslySetInnerHTML= {{__html: details.instructions}}></h3>
</div>
)}


    


                    </Info>

        </DetailWrapper>
    )
}


const DetailWrapper = styled.div `
margin-top: 10rem;
margin-bottom: 5rem;
display: flex;
.active {
    background: linear-gradient(35deg, #494949, white);
}
h2{
    margin-bottom: 2rem;
};


`;

const Button = styled.button `
padding: 1rem 2rem;
color: #313131;
background: white;
border: 2px solid black;
margin-right: 2rem;
font-weight: 600;

`;

const Info = styled.div `
margin-left: 10rem;

h3 {
    font-size: 0.8rem;
}

`;


export default Recipe;
